export const dashboardArticles = [
    {
        id: 'dashboard.overview',
        title: 'Dashboard Overview',
        category: 'Dashboard',
        order: 1,
        summary: 'Your central hub for KPIs, tasks, and quick actions',
        content: `
The Dashboard provides a quick overview of your key business metrics and recent activity. It serves as your starting point for navigating to other areas of the application.

**Key Components:**

- **KPI Cards** - Key performance indicators showing important metrics
- **My Tasks** - Tasks assigned to you that need attention
- **Recent Jobs** - Quick access to jobs you've recently worked on
- **Quick Actions** - Common actions available with one click
    `,
        expandableSections: [
            {
                title: 'Understanding KPIs',
                content: `
The KPI cards show important metrics at a glance:

- **Active Jobs** - Number of jobs currently in progress
- **Pending Orders** - Orders awaiting action
- **Unpaid Invoices** - Invoices requiring payment
- **Outstanding Claims** - Progress claims awaiting response

Click any KPI card to navigate to the relevant page with filters applied.
        `,
            },
            {
                title: 'My Tasks',
                content: `
The My Tasks section shows items requiring your attention:

- Tasks assigned to you from projects
- Approvals waiting for your review
- Deadlines approaching

Click a task to view details or mark it as complete.
        `,
            },
        ],
        keywords: ['dashboard', 'home', 'overview', 'kpi', 'tasks', 'recent'],
        route: '/dashboard',
        relatedArticles: ['getting-started.navigation', 'jobs.overview'],
        screenshots: [
            {
                src: 'dashboard/dashboard-overview.png',
                alt: 'Dashboard overview',
                caption: 'The Dashboard provides a quick overview of your projects and key metrics',
            },
            {
                src: 'dashboard/dashboard-kpis.png',
                alt: 'Dashboard KPI cards',
                caption: 'Key performance indicators show important metrics at a glance',
            },
        ],
    },
];
